import { Component, Directive, EventEmitter, Input, Output, ViewContainerRef, ChangeDetectionStrategy } from '@angular/core';
import { Question } from 'src/app/core-module/models/Audits/question';
import { formatLocalDateAnswer, parseLocalDateAnswer } from 'src/app/core-module/models/Utils/local-date-answer';
@Directive({
    selector: '[hash]',
    standalone: false
})
export class HashDirective {
  @Input() hash: string;
  constructor(public vcRef: ViewContainerRef) { }
}

@Component({
    selector: 'app-date-only',
    templateUrl: './date-only.component.html',
    styleUrls: ['./date-only.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DateOnlyComponent {
  public selectedDate: Date | null = null;
  public selectedCalendarDate: Date | null = null;

  @Input() width: string = '1/5';

  @Input() currentQuestion: Question;
  @Output() currentQuestionChange = new EventEmitter<Question>();


  ngOnChanges() {

    this.validateIncomingDate(this.currentQuestion.CompletionInfo.Answer);

  }
  ngAfterViewInit() {

  }
  validateIncomingDate(value: Date | string | null) {
    const incomingDate = parseLocalDateAnswer(value);
    this.selectedDate = incomingDate ? new Date(incomingDate.getTime()) : null;
    this.selectedCalendarDate = incomingDate ? new Date(incomingDate.getTime()) : null;
  }
  setCurrentLocalDate() {
    this.selectedCalendarDate = new Date();
    this.updateCurrentDate();
  }
  updateCurrentDate() {
    if (!this.selectedCalendarDate) {
      this.selectedDate = null;
      this.currentQuestion.CompletionInfo.Answer = null;
      this.currentQuestion.CompletionInfo.QuestionAnswered = false;
      this.currentQuestionChange.emit(this.currentQuestion);
      return;
    }

    this.selectedDate = new Date(
      this.selectedCalendarDate.getFullYear(),
      this.selectedCalendarDate.getMonth(),
      this.selectedCalendarDate.getDate()
    );
    this.currentQuestion.CompletionInfo.Answer = formatLocalDateAnswer(this.selectedDate, false);
    this.currentQuestion.CompletionInfo.QuestionAnswered = true;
    this.currentQuestionChange.emit(this.currentQuestion);
  }

}

